// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import style from './InputSwitch.scss';

type Props = {
  +value: boolean;
  +name: string;
  +handleChange: (e: Event) => void;
  +className?: { [key: string]: string };
  +optionALabel?: string;
  +optionBLabel?: string;
};

export default class InputSwitch extends Component<Props, void> {
  render() {
    const { value, handleChange, name, className, optionALabel, optionBLabel } = this.props;

    return (
      <label className={classNames(style.switch, className)}>
        <input type="checkbox"
               checked={value}
               name={name}
               onChange={handleChange}/>
        <span className={classNames(style.slider, style.round)}>
          {optionALabel && <p>{optionALabel}</p>}
          {optionBLabel && <p>{optionBLabel}</p>}
        </span>
      </label>
    );
  }
}

InputSwitch.propTypes = {
  value: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  optionALabel: PropTypes.string,
  optionBLabel: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/elements/InputSwitch/InputSwitch.jsx